import React from "react"
import Modal from "./components/Modal/Modal";
import OtpValidationMainPage from "./OtpValidationBody";


const OtpModal = ({setShowModal, showModal, email, setModalWasConfirmed, setLoadingAccountForm}: any) => {

  return (
     <div>
       <Modal
          isOpen={showModal}
          size='md'
          onDismiss={() => {
            setShowModal(false);
          }}
          modalMargins={'25% auto'}
          minHeigth={'100px'}
          borderRadius={'16px'}
       >
         <div>
           <OtpValidationMainPage
              email={email}
              setShowModal={setShowModal}
              setModalWasConfirmed={setModalWasConfirmed}
              setLoadingAccountForm={setLoadingAccountForm}
           />
         </div>
       </Modal>
     </div>
  )
}

export default OtpModal
